<template>
  <el-dialog
    :title="title"
    :visible.sync="open"
    width="500px"
    append-to-body
    @closed="dialogClosed"
  >
    <base-form
      v-model="baseData"
      :options="baseOptions"
      ref="baseForm"
      :rules="rules"
      @input="handleChange"
      label-width="100px"
    >
    </base-form>

    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="submitForm()">确 认</el-button>
      <el-button @click="cancel">取 消</el-button>
    </div>
  </el-dialog>
</template>

<script>
  import BaseForm from '@/components/form/base-form';
  import entityCodeEnums from '@/common/js/voucherEntityCode';
  export default {
    name: 'BatchConfirmDialog',
    components: {
      BaseForm,
    },
    props: {},
    data() {
      return {
        // 弹出层标题
        title: '请选择批量确认日期',
        // 是否显示弹出层
        open: false,
        // 表单参数
        baseData: {
          postDate: null,
          entityCode: null,
          params: null,
          listKey: null,
        },
      };
    },
    mounted() {},
    computed: {
      baseOptions() {
        return [
          {
            type: 'date',
            label: '确认日期',
            prop: 'postDate',
            clearable: true,
            disabled: false,
            required: true,
            span: 12,
          }, //确认日期
        ];
      },
      rules() {
        return {};
      },
    },

    methods: {
      // 取消按钮
      cancel() {
        this.open = false;
      },
      dialogClosed() {
        this.$emit('close');
      },

      handleChange() {},
      /** 提交按钮 ***/
      submitForm(cancelValidate) {
        this.$refs.baseForm
          .handleSubmit()
          .then(() => {
            this.loading.startLoading();
            this.baseData.params.postDate = this.baseData.postDate;
            this.baseData.params.cancelValidate = cancelValidate;
            this.$axios
              .post(entityCodeEnums[this.baseData.entityCode].doBatchConfirm, this.baseData.params)
              .then((res) => {
                this.loading.endLoading();
                if (0 == res.data.code) {
                  this.$message({
                    showClose: true,
                    message: res.data.msg,
                    type: 'success',
                  });
                  this.$parent.$refs.siruiTable.clearCheckboxReserve();
                  this.$parent.multipleSelection = [];
                  this.open = false;
                  this.$parent.getData();
                } else if (8 == res.data.code) {
                  this.$alert(res.data.msg);
                  this.$parent.$refs.siruiTable.clearCheckboxReserve();
                  this.$parent.multipleSelection = [];
                  this.$parent.getData();
                } else if (res.data.code === 10) {
                  this.$reportErrors({
                    msg: res.data.msg,
                    code: res.data.code,
                    callback: () => {
                      //确认提交，cancelValidate传值true取消校验
                      this.submitForm(true);
                    },
                  });
                } else {
                  this.$alert(res.data.msg);
                }
              })
              .catch(() => {
                this.loading.endLoading();
              });
          })
          .catch(() => {});
      },
      openDialog(entityCode, params, listKey) {
        this.open = true;
        this.baseData.entityCode = entityCode;
        this.baseData.params = params;
        this.baseData.listKey = listKey;
      },
    },
  };
</script>
